import script from "./BaseThreeButtonModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseThreeButtonModal.vue?vue&type=script&lang=ts&setup=true"

import "./BaseThreeButtonModal.vue?vue&type=style&index=0&id=0a56e4fe&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a56e4fe"]])

export default __exports__